// Website stock-status label and purchasability. Deliberately ignores
// product.stock - the shop controls In Stock / Out of Stock with a switch
// (isAvailable) regardless of the physical quantity on hand.
//
// isAvailable === false (not !isAvailable) so a product fetched before this
// field existed on the API reads as available, not out of stock.

export const getAvailabilityLabel = (product) => {
    if (product?.isPreOrder) return 'Pre-Order';
    if (product?.isAvailable === false) return 'Out of Stock';
    return 'In Stock';
};

export const isPurchasable = (product) => !product?.isPreOrder && product?.isAvailable !== false;
